import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFirestore as getFirestoreLite } from "firebase/firestore/lite";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyBBRqXcXHdV71x40VOunH1c8q1ap5rrY6o",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "geniusloci-4f597.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "geniusloci-4f597",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "geniusloci-4f597.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "463891854741",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:463891854741:web:2735ed4fcd7d404456729c",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-GLVH5L1TX6",
};

export const FIRESTORE_ROOT = import.meta.env.VITE_FIRESTORE_ROOT || "glooci_genia";

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const dbLite = getFirestoreLite(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
